<template>
    <div class="identifyImages" id="upLoadImage">
        <div class="main">
            <div class="top">
                <p>批量传图询价</p>
                <div class="upLoadImage">
                    <my-upload :format="['jpg','jpeg','png']"
                               :maxSize="5120"
                               :multiple="true"
                               :type="1"
                               @success="handleSuccess"
                               @uploadError="handleUploadError"
                               @formatError="handleFormatError"
                               @maxSizeError="handleMaxSizeError"
                               @progress="handleProgress"
                               @errUpload="errUpload"
                    >
                    </my-upload>

                    <div class="innerIcon">
                        <i class="iconfont icon-safa"></i>
                        <i class="iconfont icon-Tablelamp"></i>
                        <i class="iconfont icon-nighttable"></i>
                        <p>请拖拽多张单品图片到此处或点击上传</p>
                        <span>上传图片</span>
                    </div>
                </div>
            </div>

            <div class="handleProgress" v-if="(progress > 0 || progress ===100) && !errorImg" >
                <span v-if="(progress > 0 || progress ===100) && !errorImg" class="progress-loading" :style="{'width' : progress + '%'}"></span>
                <span v-else class="progress-loading" :style="{'width' : progress + '%'}" style="background: #e14b5d"></span>
            </div>

            <div class="test" v-if="isZhulogic">
                <span></span>
                每款产品将花费4个恐龙蛋，价格有效期为3个月
            </div>

            <!--产品列表-->
            <manyimage-list @getList="getList"></manyimage-list>

            <!-- <div class="button">
                <button @click="submitHandle" :disabled="marquee.quoteProducts.length === 0 || !marquee.detailedListId">立即报价</button>
            </div> -->

        </div>
        <deduction-egg ref="deduction" @offerSubmit="offerSubmit"></deduction-egg>
        <egglack-box ref="egglack" :text="text" :type="dialogType"></egglack-box>
    </div>
</template>
<script>
    import api from '../../../api';
    import config from '../../../config/config';
    import myUpload from '../../common/myUpload.vue';
    import recoghitionCon from './recognition.vue'
    import manyimageList from './manyImageList.vue';
    import deductionEgg from '../../common/deductionEgg.vue';
    import egglackBox from '../../common/eggLack.vue';

    export default {
        data() {
            return {
                imgBaseUrl: api.common.imgBaseUrl,
                isZhulogic: config.isZhulogic,
                dialogType: 1,
                text: ' 恐龙蛋余额不足，无法报价',
                progress: 0,
                marquee: {
                    'detailedListId': 0,
                    'quoteProducts': []
                },
                imgHeight: null,
                getImgConData: 0,
                actualImageH: null,  //图片的实际高度
                errorImg: false
            };
        },
        computed: {
            getData(){
                return this.$store.state.app.manyImageListData;
            }
        },
        components: {myUpload, recoghitionCon, manyimageList, deductionEgg, egglackBox},
        methods: {
            balance() {
                return this.$store.state.app.balance
            },
            getList(id){
                this.marquee.detailedListId = id;
            },
            errUpload(){
                this.errorImg = true;
            },
            handleSuccess(value){
                this.errorImg = false;
                this.progress = 0;
                this.imgAjax(value)
            },
            handleUploadError(){
                this.errorImg = false;
                this.$Message.error('上传失败,请重新上传');
            },
            handleFormatError(){
                this.$Message.error('请选择 jpg,jpeg 或 png 格式的文件');
            },
            handleMaxSizeError(){
                this.$Message.error('请选择小于 5M 的图片');
            },
            handleProgress(progress){
                this.errorImg = false;
                this.progress = progress;
            },
            imgAjax(value){
                api.imgSearch.detect_url(this.imgBaseUrl + value.data[0].key)
                    .then(res => {
                        let name;
                        if (!res.detectedBoxes || res.detectedBoxes.length === 0) {
                            name = '其他'
                        } else {
                            name = res.detectedBoxes[0].type
                        }
                        let o = {
                            'material': '常规',
                            'name': name,
                            'remark': '',
                            'size': '常规',
                            'partFiles': value.data
                        }
                        this.marquee.quoteProducts.push(o);
                        console.log(this.marquee.quoteProducts)
                        console.log(this.marquee.detailedListId)
                        this.$store.dispatch('getManyImageList', this.marquee);
                    })
            },
            submitHandle(){
                if(!this.isZhulogic ){
                    return this.offerSubmit();
                }
                //提示恐龙蛋
                let needBalance = parseInt(this.marquee.quoteProducts.length * 4);
                if (needBalance <= this.balance()) {
                    this.$refs.deduction.open('offer', needBalance);
                } else {
                    this.$refs.egglack.open();
                }
            },
            offerSubmit(){
                api.imgSearch.batch_quote(this.getData)
                    .then(res => {
                        this.$Message.success('报价成功！');
                        this.$router.push({name: 'mySuccessQuoting', params: {id: res}});
                    })
            }
        },
        destroyed(){
            //重置数据
            this.$store.dispatch('getManyImageList', null);
        },
        created() {
            this.$store.dispatch('getBalance');
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped type="text/scss">
    .identifyImages {
        width: 100%;
        background: #fff;
        padding-top: 33px;
        padding-bottom: 45px;
        .main {
            width: 1130px;
            margin: 0px auto;
            .top {
                p {
                    font-size: 24px;
                    color: #353838;
                    margin-bottom: 19px;
                }
                .isShowImg {
                    width: 100%;
                    text-align: center;
                    position: relative;
                    font-size: 0px;
                    .innerIconspaecail {
                        background: #6C6F70;
                        opacity: 0.7;
                        padding: 20px;
                        display: inline-block;
                        position: absolute;
                        left: 495px;
                        z-index: 10;
                        .ivu-chart-circle-inner {
                            span {
                                color: #fff;
                            }
                        }
                    }
                }
                .upLoadImage {
                    width: 100%;
                    height: 420px;
                    background:rgba(247,247,247,1);
                    border-bottom: none;
                    text-align: center;
                    cursor: pointer;
                    position: relative;
                    .innerIcon {
                        display: inline-block;
                        position: absolute;
                        top: 0;
                        left: 390px;
                        z-index: 10;
                        i {
                            display: inline-block;
                            color: #353838;
                            font-size: 68px;
                            margin-top: 119px;
                        }
                        p {
                            font-size: 20px;
                            color: #353838;
                            margin-top: 15px;
                        }
                        span {
                            display: inline-block;
                            background: #313131;
                            height: 39px;
                            width: 132px;
                            text-align: center;
                            line-height: 39px;
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-top: 15px;
                            &:hover {
                                opacity: 0.8;
                            }
                        }
                    }
                    .innerIconspaecail {
                        display: inline-block;
                        position: absolute;
                        top: 150px;
                        left: 495px;
                        z-index: 10;
                    }
                }
            }

            .handleProgress {
                width: 100%;
                height: 16px;
                background: #C8CCCC;
                margin-top: 0px;
                position: relative;
                .progress-loading {
                    position: absolute;
                    width: 20%;
                    height: 100%;
                    background: #99C72C;
                    left: 0px;
                    top: 0px;
                }
            }

            .test {
                font-size: 14px;
                color: #353838;
                margin-top: 15px;
                span {
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    background: #E14B5D;
                    border-radius: 50%;
                    vertical-align: middle;
                    margin-right: 12px;
                    margin-top: -3px;
                }
            }
            .button {
                margin-top: 28px;
                text-align: center;
                button {
                    width: 317px;
                    height: 50px;
                    border-radius: 0px;
                    color:#fff;
                    background: #E14B5D;
                    &:disabled {
                        background: #c8cccc;
                        cursor: default;
                    }
                    &:hover {
                        opacity: 0.8;
                    }
                }
                p {
                    width: 317px;
                    text-align: left;
                    font-size: 14px;
                    color: #E14B5D;
                    margin: 0 auto;
                }
            }
        }
    }
</style>

<style>
    #upLoadImage .upload {
        position: relative;
        z-index: 99;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

    #upLoadImage .ivu-upload {
        height: 100%;
    }

    #upLoadImage .ivu-upload-select {
        width: 100%;
        height: 100%;
    }
</style>

